<template>
	<div class="flex-wrapper">
		<div class="title-text">
			{{ messages.formTitle }}
			<Tag v-if="isDeleted"><DeleteOutlined /> {{ $t('baselines.statuses.deleted') }}</Tag>
		</div>
		<Badge
			v-if="isDeleted"
			status="default"
			:text="$t('baselines.statuses.deleted')"
		/>
		<template v-if="baselineObjRef !== null">
			<Badge
				v-if="baselineObjRef.message === ''"
				class="test-status-display"
				:status="baselineObjRef.statusData.badge"
				:text="$t('baselines.statuses.' + baselineObjRef.statusData.key)" />
			<Tooltip
				v-else
				placement="left"
			>
				<template #title>
					<div class="strong">{{ $t('baselines.statusErrorMessage') }}</div>
					<div v-if="baselineObjRef.message">{{ baselineObjRef.message }}</div>
				</template>
				<span class="ant-badge-status-text nobr">
					<InfoCircleOutlined :style="{ color: colorRed, marginInlineEnd: '4px' }" /> {{ $t('baselines.statuses.' + baselineObjRef.statusData.key) }}
				</span>
			</Tooltip>
		</template>
	</div>
</template>

<script>
import { toRef, computed } from 'vue';

import { Badge, Tooltip, Tag } from 'ant-design-vue';
import { InfoCircleOutlined, DeleteOutlined } from '@ant-design/icons-vue';

import Consts from '@/api/Consts';


export default {
	components: {
		Badge, Tooltip, Tag,
		InfoCircleOutlined, DeleteOutlined,
	},
	props: ['baselineObj', 'baselineDetails', 'messages'],
	setup(props) {
		const baselineObjRef = toRef(props, 'baselineObj');
		const baselineDetailsRef = toRef(props, 'baselineDetails');
		const isDeleted = computed(() => baselineObjRef.value === null && baselineDetailsRef.value.deleted);
		return {
			baselineObjRef,
			isDeleted,
			colorRed: Consts.COLORS.errorDark,
		}
	}
}
</script>

<style scoped>
.title-text {
	flex: 1;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
</style>
